import React from "react";

import './courseAnalytics.css'

function CourseAnalyticsView(){
    return(
        <>
            <h1 style={{marginLeft:'260px'}}>Course Analytics</h1>
        </>
    )
}

export default CourseAnalyticsView;